import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "alarm-view-container" }
const _hoisted_2 = { class: "alarm-summary-card" }
const _hoisted_3 = { class: "alarm-summary-card__header" }
const _hoisted_4 = { class: "alarm-summary-card__title" }
const _hoisted_5 = { class: "alarm-summary-card__title-text" }
const _hoisted_6 = { class: "alarm-summary-card__body" }
const _hoisted_7 = {
  key: 0,
  class: "alarm-loading-row"
}
const _hoisted_8 = {
  key: 1,
  class: "alarm-error-row",
  role: "alert"
}
const _hoisted_9 = {
  key: 2,
  class: "alarm-summary-grid"
}
const _hoisted_10 = { class: "alarm-summary-tile alarm-summary-tile--total" }
const _hoisted_11 = { class: "alarm-summary-tile__content" }
const _hoisted_12 = { class: "alarm-summary-tile__value" }
const _hoisted_13 = { class: "alarm-summary-tile__label" }
const _hoisted_14 = { class: "alarm-summary-tile alarm-summary-tile--triggered" }
const _hoisted_15 = { class: "alarm-summary-tile__content" }
const _hoisted_16 = { class: "alarm-summary-tile__value" }
const _hoisted_17 = { class: "alarm-summary-tile__label" }
const _hoisted_18 = { class: "alarm-summary-tile__meta" }
const _hoisted_19 = { class: "alarm-summary-tile alarm-summary-tile--ok" }
const _hoisted_20 = { class: "alarm-summary-tile__content" }
const _hoisted_21 = { class: "alarm-summary-tile__value" }
const _hoisted_22 = { class: "alarm-summary-tile__label" }
const _hoisted_23 = { class: "alarm-grid-card" }
const _hoisted_24 = {
  key: 0,
  class: "alarm-empty-row"
}
const _hoisted_25 = { class: "alarm-grid-card__header" }
const _hoisted_26 = { class: "alarm-grid-card__title" }
const _hoisted_27 = { class: "alarm-grid-card__title-text" }
const _hoisted_28 = { class: "alarm-grid-card__controls" }
const _hoisted_29 = { class: "alarm-search" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "alarm-grid-card__body" }
const _hoisted_32 = { class: "alarm-status-pill" }
const _hoisted_33 = { class: "alarm-status-label" }
const _hoisted_34 = { class: "alarm-acronym-cell" }
const _hoisted_35 = { class: "alarm-counter-cell" }
const _hoisted_36 = { class: "alarm-last-heard-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["alarm-summary-card__icon", _ctx.hasTriggeredAlarms ? 'alarm-summary-card__icon--alert' : 'alarm-summary-card__icon--ok'])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.hasTriggeredAlarms ? 'bi bi-exclamation-triangle-fill' : 'bi bi-check-circle-fill')
            }, null, 2)
          ], 2),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('components.assetDetails.alarms.emergencyTriggered')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("div", {
                class: "spinner-border spinner-border-sm",
                role: "status",
                "aria-hidden": "true"
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.alarms.loading')), 1)
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.alarms.errorLoading')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "alarm-summary-tile__icon" }, [
                    _createElementVNode("i", { class: "bi bi-bell-fill" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.summary.total), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('components.assetDetails.alarms.summary.total')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "alarm-summary-tile__icon" }, [
                    _createElementVNode("i", { class: "bi bi-exclamation-circle-fill" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.summary.triggered), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('components.assetDetails.alarms.summary.triggered')), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('components.assetDetails.alarms.summary.last24h')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "alarm-summary-tile__icon" }, [
                    _createElementVNode("i", { class: "bi bi-check-circle-fill" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.summary.notTriggered), 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('components.assetDetails.alarms.summary.notTriggered')), 1)
                  ])
                ])
              ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      (!_ctx.loading && _ctx.alarms.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-check-circle-fill" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.alarms.noAlarms')), 1)
          ]))
        : (!_ctx.loading && _ctx.alarms.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "alarm-grid-card__title-icon" }, [
                    _createElementVNode("i", { class: "bi bi-table" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('components.assetDetails.alarms.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-search alarm-search__icon" }, null, -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                      class: "alarm-search__input",
                      type: "text",
                      placeholder: _ctx.$t('components.assetDetails.alarms.searchPlaceholder')
                    }, null, 8, _hoisted_30), [
                      [_vModelText, _ctx.searchValue]
                    ]),
                    (_ctx.searchValue)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "alarm-search__clear",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchValue = ''))
                        }, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_ctx.filteredAlarms.length > 0)
                  ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                      key: 0,
                      "data-source": _ctx.filteredAlarms,
                      "show-borders": false,
                      "show-column-lines": false,
                      "hover-state-enabled": true,
                      "allow-column-reordering": true,
                      "allow-column-resizing": true,
                      "column-auto-width": true,
                      "column-hiding-enabled": true,
                      height: "auto",
                      class: "alarm-dx-grid"
                    }, {
                      "status-cell": _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "alarm-status-dot" }, null, -1)),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('components.assetDetails.alarms.triggered')), 1)
                        ])
                      ]),
                      "code-cell": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(data.data.param_name.replace('DKN_LMS_', '')), 1)
                      ]),
                      "counter-cell": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(data.data.count), 1)
                      ]),
                      "last-heard-cell": _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(data.data.last_occurrence ? _ctx.relativeTime(data.data.last_occurrence) : '—'), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_DxPaging, { "page-size": 10 }),
                        _createVNode(_component_DxPager, {
                          "allowed-page-sizes": [10, 25, 50],
                          "show-info": true,
                          "show-navigation-buttons": true,
                          "show-page-size-selector": true
                        }),
                        _createVNode(_component_DxFilterRow, { visible: false }),
                        _createVNode(_component_DxColumn, {
                          caption: _ctx.$t('components.assetDetails.alarms.columns.status'),
                          "cell-template": "status-cell",
                          width: 110,
                          alignment: "center"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          caption: _ctx.$t('components.assetDetails.alarms.columns.alarm'),
                          "data-field": "description",
                          "min-width": 200,
                          alignment: "left"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          caption: _ctx.$t('components.assetDetails.alarms.columns.code'),
                          "data-field": "param_name",
                          width: 150,
                          alignment: "center",
                          "cell-template": "code-cell"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          caption: _ctx.$t('components.assetDetails.alarms.columns.counter'),
                          "data-field": "count",
                          width: 110,
                          alignment: "center",
                          "sort-order": "desc",
                          "cell-template": "counter-cell"
                        }, null, 8, ["caption"]),
                        _createVNode(_component_DxColumn, {
                          caption: _ctx.$t('components.assetDetails.alarms.columns.lastHeard'),
                          "data-field": "last_occurrence",
                          width: 170,
                          alignment: "center",
                          "cell-template": "last-heard-cell"
                        }, null, 8, ["caption"])
                      ]),
                      _: 1
                    }, 8, ["data-source"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}